define("ember-svg-jar/inlined/social-inbox", ["exports"], function (_exports) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  var _default = _exports.default = {
    "content": "<g clip-path=\"url(#a)\"><path d=\"M14 2.333L2.333 11.667v11.666l2.334 2.334h18.666l2.334-2.334V11.667L14 2.333zm2.205 14.56h-4.398l-5.962-4.818 8.167-6.603 8.166 6.603-5.961 4.818h-.012z\"/></g><defs><clipPath id=\"a\"><path d=\"M0 0h28v28H0z\"/></clipPath></defs>",
    "attrs": {
      "xmlns": "http://www.w3.org/2000/svg",
      "width": "28",
      "height": "28",
      "fill": "currentColor",
      "viewBox": "0 0 28 28"
    }
  };
});